import { Component, Inject } from "@angular/core";
import { UserService } from "../../services/user.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AppService } from '@ui-components/services';
import { IProfile } from 'projects/ui-components/src/interfaces/IProfile';
import { switchMap } from "rxjs";
import { ICohort, IResponse, IUser } from "@interfaces/index";
import { CohortService } from "../../services/cohort.service";


@Component({
  selector: 'app-add-cohort-user-modal',
  templateUrl: './add-cohort-user-modal.component.html',
  styleUrl: './add-cohort-user-modal.component.scss'
})
export class AddUserModalComponent {

  form: FormGroup;
  profile: IProfile | null = null;
  users: IUser[] = [];
  cohorts: ICohort[] = []
  loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: number,
    protected _app_service: AppService,
    protected _cohort_service: CohortService,
    protected _user_service: UserService,
    protected _fb: FormBuilder,
    protected _dialog_ref: MatDialogRef<AddUserModalComponent>

  ) {
    this.form = this._fb.group({
      user_ids: [null]
    })
  }

  ngOnInit() {
    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data
          return this._cohort_service.getAll(this.profile.org_id);
        }
      ),
      switchMap(
        (response: IResponse<ICohort[]>) => {
          this.cohorts = response.data;
          return this._user_service.getUsers(this.profile?.org_id as number);
        }
      )
    ).subscribe(
      (response: IResponse<IUser[]>) => {
        this.users = response.data;
        this.loading = false;
      }
    )
  }

  add() {
    if( this.data){
      this._cohort_service.addUser(this.data, this.form.get('user_ids')?.value).subscribe(
        () => {
          this._dialog_ref.close(true);
        }
      )
    }
  }
}
